import { theme } from '@theme';

export const helpCenterCategoryItem = {
  color: theme.palette.common.darkGrey12,
  marginLeft: '-32px',
  marginRight: '-32px',
  padding: '12px 32px',
  cursor: 'pointer',
  borderLeft: `4px solid transparent`
};

export const helpCenterCategoryItemActive = {
  color: theme.palette.common.primaryDark,
  fontWeight: 600,
  borderLeftColor: theme.palette.common.darkPink
};
